import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Currency} from '../../services/currency.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatSelect} from "@angular/material/select";

@Component({
  selector: 'app-currency',
  templateUrl: './currency.component.html',
  styleUrls: ['./currency.component.scss']
})
export class CurrencyComponent implements OnInit, AfterViewInit {

  @ViewChild('select', {static: true}) currencySelect: ElementRef;
  @ViewChild('matSelect', {static: true}) select: MatSelect;

  @Input() header: string;
  @Input() currencies: Currency[];
  @Input() rate: string;

  @Output() amountChanged: EventEmitter<number> = new EventEmitter<number>();
  @Output() currencyChanged: EventEmitter<Currency> = new EventEmitter<Currency>();
  @Output() clearOtherCurrency: EventEmitter<null> = new EventEmitter<null>();

  form: FormGroup = new FormGroup({
    currency: new FormControl(),
    amount: new FormControl('', Validators.pattern('^(\\d+|\\d{1,3}(,\\d{3})*)(\\.\\d+)?$'))
  });

  public calculatedAmount: number;
  selectedCurrency: Currency;
  @Input() otherCurrency: Currency;
  visibleCurrencies: any;

  constructor() {
  }

  ngOnInit() {
  }

  onAmountChange() {
    this.calculatedAmount = null;
    if (this.form.valid) {
      this.amountChanged.emit(this.form.value.amount.toString().replace(/,/g, ''));
    }
  }

  onCurrencyChange() {
    if (this.form.value.currency != null) {
      if (this.form.valid) {
        this.currencyChanged.emit(this.form.value.currency);
      }
    }
  }

  public setCalculatedAmount(amount: number) {
    amount = +amount;
    this.calculatedAmount = amount;
    if (amount) {
      this.calculatedAmount = +amount.toFixed(this.selectedCurrency.decimals);
    }
    this.form.patchValue({amount: ''});
  }

  ngAfterViewInit(): void {

  }

  getString() {

  }

  public clear() {
    this.form.patchValue({currency: ''});
  }

  setCurrency(currency: string) {

    setTimeout(() => {
      this.form.patchValue({
        currency: this.currencies.find(c => c.alpha3 === currency)
      });
      this.selectedCurrency = this.currencies.find(c => c.alpha3 === currency);
      this.onCurrencyChange();
    }, 1000);
  }

  setAmount(amount: number) {

    setTimeout(() => {
      this.form.patchValue({
        amount: amount
      });
      this.onAmountChange();
    }, 1000);
  }

  setCurrencies(currencies: Currency[]) {
    this.currencies = currencies;
  }

  currencyClick() {
    // console.log(this.currencySelect.nativeElement);
    // this.currencySelect.nativeElement.dispatchEvent(new Event('click'));
    this.select.open();
  }
  // currencyFocus() {
  //   this.visibleCurrencies = this.currencies.map((c)=>{
  //     return {
  //       alpha3: c.alpha3,
  //       label: `${c.alpha3} - ${c.name}`
  //     }
  //   });
  // }
  //
  // currencyBlur() {
  //   this.visibleCurrencies = this.currencies.map((c)=>{
  //     return {
  //       alpha3: c.alpha3,
  //       label: `${c.alpha3} - ${c.name}`
  //     }
  //   });
  //   this.visibleCurrencies = this.currencies.map((c)=>{
  //     return {
  //       alpha3: c.alpha3,
  //       label: c.alpha3
  //     }
  //   });
  // }
}
